<mat-card class="slidecontent">
    <div class="headcontent">
        <div class="pophead">
            <h3>Create Role</h3>
        
            <mat-icon (click)="close(closePannel)" class="close">close</mat-icon>
        
        </div>
    </div>
        <div class="dialog_content">

           
            <form [formGroup]="roleDetailform">
        
                <mat-form-field class="mb-5">
                    <mat-label>Save Role As:</mat-label>
                    <input matInput maxlength="30" placeholder="Role Name" name="name" formControlName="name" #name>
                    <mat-error> {{ titleAlert }}</mat-error>
                </mat-form-field>
        
                <mat-form-field class="mb-5">
                    <mat-label>Description:</mat-label>
                    <textarea matInput placeholder="Role Description" name="description" formControlName="description" rows="5">
                    </textarea>
                    <mat-error> {{ titleAlert }}</mat-error>
                </mat-form-field>
        
                <!-- <label for="Permissions">Permissions</label>
                <ng-multiselect-dropdown [placeholder]="'Select Permissions'"
                 [data]="dropdownList" name="selectedPermission"
                 formControlName="selectedPermission" [settings]="dropdownSettings" 
                 [(ngModel)]="selectedItems" (ngModelChange)="getSelectedPermission($event)">
                </ng-multiselect-dropdown> -->

                <div class="selectedPermission mb-5">
                    <h4>Select Permissions </h4>
                    <div class="multiDrop">
                        <ng-multiselect-dropdown
                        [placeholder]="'Search or Select'"
                        [settings]="dropdownSettings"
                        [data]="dropdownList"
                        [(ngModel)]="selectedItems"
                        formControlName="selectedPermission"                
                        name="selectedPermission"
                         >
                        </ng-multiselect-dropdown>
                       </div>
                </div>    
               
        
            
                <!-- <mat-form-field>
                <mat-select placeholder = "Select Permissions"  formControlName="selectedPermission"
                    [(ngModel)]="selectedItems" name = "selectedPermission" multiple>
                    <mat-option *ngFor = "let perm of permList" 
                        [value] = "perm.permissionID">
                        {{perm.permissionName}}
                    </mat-option>
                </mat-select>
                </mat-form-field> -->
        
            </form>
        </div>
    
    
    
    <div class="actionBtn">
    
        <button mat-flat-button class="cancel" (click)="close(closePannel)">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" [disabled]="!roleDetailform.valid"
            (click)="save(roleDetailform.value)" color="primary">Create</button>
    </div>
</mat-card>

<div class="overlay" (click)="close(closePannel)" ></div>
  



  